import {KEYS, getData} from '@/store';
import {feLogger} from './index';

enum RepType {
    Click = 'click',
    Show = 'show',
}

const reportIds = {
    entityShow: '80001.10.1',
    entityClick: '80001.10.2',
    entityCardClick: '80001.10.3',
    entityBlock: '80001.10.4',
    entityLike: '80001.10.5',
    entityShowScreen: '80001.10.6',
    entityKuLinkClick: '80001.10.7',
    entityShowScreen2: '80001.10.8',
    entityShowDuration: '80001.10.9',
    feedback: '80001.10.10',
    feedbackClick: '80001.10.11',
    logoClick: '80001.10.12',
    polyExpandClick: '80001.10.13',
    polyLinkClick: '80001.10.14',
};

// 展现
export const reportEntityShow = (list: any, pvId: string) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    const entityNames: string = list.map((item: any) => item.entityName).join(',');

    return feLogger({
        rep_id: reportIds.entityShow,
        rep_type: RepType.Show,
        rep_params: {
            page_id: curDoc.docGuid,
            tag_list: entityNames,
            tag_number: list.length,
            // 当前PV生成的唯一ID
            sessionId: pvId,
        },
    });
};

// 词条点击
export const reportEntityClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.entityClick,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};

// 卡片点击
export const reportEntityCardClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.entityCardClick,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};

// 屏蔽
export const reportEntityBlock = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.entityBlock,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};

// 点赞
export const reportEntityLike = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.entityLike,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};

// 词条展现在屏幕中
export const reportEntityShowScreen = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    if (curDoc) {
        feLogger({
            rep_id: reportIds.entityShowScreen,
            rep_type: RepType.Show,
            rep_params: {
                page_id: curDoc.docGuid,
                ...options,
            },
        });
    }
};

// 词条展现在屏幕中，新增了pv id，用于星链的CTR统计
export const reportEntityShowScreen2 = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    if (curDoc) {
        feLogger({
            rep_id: reportIds.entityShowScreen2,
            rep_type: RepType.Show,
            rep_params: {
                page_id: curDoc.docGuid,
                ...options,
            },
        });
    }
};

// 点击卡片内的知识库链接
export const reportEntityKuLinkClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.entityKuLinkClick,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};

// 卡片曝光时长
export const reportStarLinkShowDuration = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.entityShowDuration,
        rep_type: RepType.Show,
        rep_params: {
            page_id: curDoc.docGuid,
            tag_id: options.entityId,
            tag_name: options.entityName,
            duration: options.duration,
        },
    });
};

// 用户反馈信息上报
export const reportFeedback = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.feedback,
        rep_type: RepType.Show,
        rep_params: {
            page_id: curDoc.docGuid,
            tag_id: options.entityId,
            tag_name: options.entityName,
            reason: options.reason,
            input_reason: options.inputReason,
        },
    });
};

// 反馈点击
export const reportFeedbackClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.feedbackClick,
        rep_type: RepType.Show,
        rep_params: {
            page_id: curDoc.docGuid,
            tag_id: options.entityId,
            tag_name: options.entityName,
        },
    });
};

// 智能知识助手logo点击
export const reportLogoClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.logoClick,
        rep_type: RepType.Show,
        rep_params: {
            page_id: curDoc.docGuid,
            tag_id: options.entityId,
            tag_name: options.entityName,
        },
    });
};

// 点击卡片内的多义词展开收起
export const reportPolyExpandClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.polyExpandClick,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};

// 点击卡片内的多义词链接
export const reportPolyLinkClick = (options: any) => {
    const curDoc = getData(KEYS.CUR_DOCUMENT);

    return feLogger({
        rep_id: reportIds.polyLinkClick,
        rep_type: RepType.Click,
        rep_params: {
            page_id: curDoc.docGuid,
            ...options,
        },
    });
};
